import Select, { components } from 'react-select';
import { memo } from 'react';
import { DropdownIndicatorIcon } from '../utils/svg-icon';
import './select.css';

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <DropdownIndicatorIcon />
  </components.DropdownIndicator>
);

export const SelectInput = memo(({ ...props }) => {
  return (
    <Select
      value={props.value}
      onChange={(event) => {
        props.handleChange(event)
      }}
      onBlur={props.handleBlur}
      options={props.options}
      isSearchable={props.isSearchable}
      placeholder={props.placeholder}
      className="ui-form-select"
      classNamePrefix='ui-react-select'
      components={{ DropdownIndicator }}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: 'none',
        },
      })}
      styles={{
        option: (styles, { isSelected }) => ({
          ...styles,
          ':active': {
            ...styles[':active'],
            backgroundColor: undefined
          }
        })
      }}
    />
  )
})
